import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { Metadata } from '../base/Metadata'

@ObjectType()
@InputType('ChatMetadataInput')
@modelOptions({ schemaOptions: { strict: false } })
export class ChatMetadata extends Metadata {
  @Field(() => String)
  @Prop({ type: String, index: true })
  orderId: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  purchaseOrderId: string
}
